// extracted by mini-css-extract-plugin
export default {"root":"kNlZ___root","fullscreen":"bPxbC__fullscreen"};